export default {

    impacts: 'Impacts',
    impactFactors: 'Impact Factors',
    impactFactor: 'Impact Factor',
    impactMeasures: 'Impact Levels',
    saveMeasures: 'Save Measures',
    addImpactFactor: 'Add Impact Factor',
    savingImpactMeasures: 'Saving Impact Measures',
    impactMeasuresSavedSuccessfully: 'Impact measures saved successfully',
    loadingImpactMeasures: 'Loading impact measures...',
    savingImpactFactor: 'Saving impact factor',
    theImpactFactor: 'the impact factor!',
    errorDeletingImpactFactor: 'An error occurred while deleting the impact factor!',
    impactFactorDeletedSuccessfully: 'Impact factor deleted successfully!',
    impact: 'Impact',
    impactLevel: 'Impact Level',
    noImpactFactor: 'The impact factor does not exist',
    noImpactFactors: 'There are no impact factors',
    whatIsImpactFactor: 'What is an impact factor?',
    impactDefinition: 'represents the level of impact on your organization\'s assets.',
    impactGuide: ', which that allow you to quantify your reach. To facilitate your analysis, we have prepared some default impact factors. You can enable them for your organization or add new ones for your company',
    measuredBy: 'It is measured through',
    goToImpactSection: 'Go to the impact section',
};
